import { render, staticRenderFns } from "./SigleQuizz.vue?vue&type=template&id=8f37a9ec&"
import script from "./SigleQuizz.vue?vue&type=script&lang=js&"
export * from "./SigleQuizz.vue?vue&type=script&lang=js&"
import style0 from "./SigleQuizz.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports